import * as React from 'react'
import cx from 'classnames'
import { ReactComponent as AlertIcon } from 'assets/icons/alert15.svg'

import Styles from './FormErrorMessage.module.scss'

interface Props {
  children: React.ReactNode
  className?: string
}

export const FormErrorMessage = ({ className, children }: Props) => {
  return (
    <div className={cx(Styles.errorMessage, className)}>
      <AlertIcon className={Styles.alertIcon} />
      <div className={Styles.errorText}>{children}</div>
    </div>
  )
}
